// @flow
import React from 'react';
import styled from 'styled-components';

import { TYPE_SCALE_F6 } from 'styles/type-scale';
import { FONT_WEIGHT_100 } from 'styles/font-weight';
import { LINE_HEIGHT_COPY } from 'styles/line-height';
import { LINK_COLOR_TERTIARY, LINK_COLOR_QUATERNARY } from 'styles/colors';
import { BORDER_WIDTH_1 } from 'styles/borders';
import { EASE_IN_OUT_25 } from 'styles/transitions';

const TermsAndServices = () => (
  <Copy>
    By submitting payment, I agree to the
    <Link
      href="https://www.hiclark.com/terms-of-service/"
      rel="noopener noreferrer"
      target="_blank"
    >
      {' '}
      Terms of Service.
    </Link>
  </Copy>
);

export default TermsAndServices;

const Copy = styled.p`
  ${TYPE_SCALE_F6};
  ${FONT_WEIGHT_100};
  ${LINE_HEIGHT_COPY};
  color: ${LINK_COLOR_TERTIARY};
  margin: 0;
`;

const Link = styled.a`
  ${TYPE_SCALE_F6};
  border-bottom: ${BORDER_WIDTH_1} dashed ${LINK_COLOR_TERTIARY};
  color: ${LINK_COLOR_TERTIARY};
  text-decoration: none;
  ${EASE_IN_OUT_25};
  &:hover {
    color: ${LINK_COLOR_QUATERNARY};
    border-bottom: ${BORDER_WIDTH_1} dashed ${LINK_COLOR_QUATERNARY};
  }
`;



// WEBPACK FOOTER //
// ./src/components/terms-and-services/index.js